import Link from "next/link";
import "./videoCard.scss";
import Image from "next/image";
import { truncateText } from "@/utils/truncateText";

export default function VideoCard({ video }) {
  return (
    <Link href={`/how-its-work/${video?.slug}`} className="h-full block">
      <div className="videoCardWrapper h-full">
        <div className="videoImgContainer">
          <Image
            src={video?.img?.url}
            alt={video?.title || 'Video thumbnail'}
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            priority
            className="object-cover"
          />
        </div>
        {video?.title && (
          <p className="videoHeading">
            {truncateText(video?.title || video?.description, 30)}
          </p>
        )}
      </div>
    </Link>
  );
}
